import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="py-20 bg-navy-50" data-id="element-104">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-105">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-2xl p-8 md:p-12 shadow-xl border-t-4 border-orange text-center relative" data-id="element-106">
          <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-white rounded-full p-2 shadow-lg" data-id="element-107">
            <div className="bg-orange text-white rounded-full p-4" data-id="element-108">
              <ShieldCheck size={40} data-id="element-109" />
            </div>
          </div>

          <h2 className="font-heading text-3xl md:text-4xl font-bold text-navy mt-8 mb-6" data-id="element-110">
            Garantía de Hierro: 7 Días Sin Riesgo
          </h2>

          <div className="space-y-6 text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto" data-id="element-111">
            <p className="font-medium" data-id="element-112">
              Chile es un país de escépticos, y lo entiendo completamente.
            </p>

            <p data-id="element-113">
              Por eso te ofrezco esto: prueba el sistema durante 7 días
              completos. Si no sientes que estás durmiendo mejor, que tienes más
              control sobre tus nervios y que las mañanas del lunes ya no te
              generan pánico, me escribes un correo y te devuelvo el 100% de tu
              dinero.
            </p>

            <p className="font-bold text-navy text-xl" data-id="element-114">
              Sin preguntas. Sin formularios. Sin resentimientos.
            </p>

            <p className="text-orange font-bold text-xl uppercase tracking-wide" data-id="element-115">
              El riesgo es completamente mío.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}